module.exports = __webpack_public_path__ + "static/img/3毫米波雷达.5d73d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/解决方案/农机无人驾驶解决方案/3毫米波雷达.png
// module id = /2V4
// module chunks = 0